import { Observable, Subject } from 'rxjs';

import { AdditionalContact } from 'components/ProviderData/IpaAdministration/atoms/Models';
export interface ClaimDepartmentResponse {
    error: boolean;
    message?: string;
    newRecordId?: string;
    isRecordUpdated?: number;
    id: number;
    triggerIdCardWorkflow?: boolean;
}
const selectedIpaClaimDepartmentSubject = new Subject<AdditionalContact>();
const submitClaimDepartmentSubject = new Subject<void>();
const claimDepartmentResponseSubject = new Subject<ClaimDepartmentResponse>();
const claimDepartmentService = {
    select: (contact: AdditionalContact) => {
        selectedIpaClaimDepartmentSubject.next(contact);
    },
    get$: (): Observable<AdditionalContact> => selectedIpaClaimDepartmentSubject.asObservable(),
    submit: () => submitClaimDepartmentSubject.next(),
    submit$: (): Observable<void> => submitClaimDepartmentSubject.asObservable(),
    setResponse: (response: ClaimDepartmentResponse) => claimDepartmentResponseSubject.next(response),
    response$: (): Observable<ClaimDepartmentResponse> => claimDepartmentResponseSubject.asObservable(),
};

export { claimDepartmentService };
